import { useState } from "react";

//import material
import {
  Grid,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Card,
  Paper,
  CardHeader,
  Typography,
  CardContent,
  Button,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
  Divider,
  Box,
  Stack,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import axios from "axios";

//project components
import WorkExperienceForm from "../work-experience/WorkExperienceForm";
import config from "../../../../config";

const WorkExperience = (props) => {
  const { workExperiences, onSave, candidateId } = props;
  //const [qualifications, setQualifications] = useState([]);
  const [openAdd, setOpenAdd] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedWorkExperience, setSelectedWorkExperience] = useState({
    id: 0,
    candidateId: candidateId,
    companyName: "",
    position: "",
    salary: 0,
    fromDate: new Date(),
    toDate: new Date(),
    isCurrent: false,
  });

  const handleAdd = () => {
    setSelectedWorkExperience({
      id: 0,
      candidateId: candidateId,
      companyName: "",
      position: "",
      salary: 0,
      fromDate: new Date(),
      toDate: new Date(),
      isCurrent: false,
    });
    setOpenAdd(true);
  };

  const handleDelete = () => {
    axios
      .delete(
        config.serverURL +
          "/api/CandidateWorkExpriences/" +
          selectedWorkExperience.id
      )
      .then((response) => {
        onSave();
        setOpenDelete(false);
      })
      .catch((error) => {
        console.log(error);
        setOpenDelete(false);
      });
  };

  const handleSave = () => {
    onSave();
    setOpenAdd(false);
  };

  const handleCancel = () => {
    setOpenAdd(false);
  };

  const handleCancelDelete = () => {
    setOpenDelete(false);
  };

  return (
    <Card elevation={3}>
      <Grid
        sx={{
          background: "linear-gradient(to right,#4a7dcf 0%, #2a569f 100%)",
          paddingX: 2,
          paddingY: 0.5,
        }}
      >
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item>
            <Typography
              variant="h6"
              sx={{
                color: "#ffffff",
              }}
            >
              Work Experience
            </Typography>
          </Grid>
          <Grid item>
            <IconButton onClick={handleAdd}>
              <AddIcon sx={{ color: "#ffffff" }} />
            </IconButton>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Box
          sx={{
            display: { xs: "flex", md: "none" },
            flexDirection: "column",
          }}
        >
          {workExperiences.map((workExperience, index) => {
            return (
              <Card
                key={index}
                variant="outlined"
                sx={{
                  margin: 1,
                  paddingX: 1,
                  paddingY: 2,
                  display: "flex",
                  justifyContent: "space-between",
                  backgroundColor: "#F5F5F5",
                }}
              >
                <Stack spacing={1}>
                  <Typography>
                    <b>Company:</b> {workExperience.companyName}
                  </Typography>
                  <Typography>
                    <b>Position:</b> {workExperience.position}
                  </Typography>
                  <Typography>
                    <b>Duration:</b>{" "}
                    {new Date(workExperience.fromDate).toLocaleDateString(
                      "hi-IN"
                    )}{" "}
                    -
                    {workExperience.isCurrent
                      ? "Till Today"
                      : new Date(workExperience.toDate).toLocaleDateString(
                          "hi-IN"
                        )}
                  </Typography>
                </Stack>
                <Stack alignItems="center" justifyContent="center" spacing={2}>
                  <IconButton
                    variant="outlined"
                    color="primary"
                    size="small"
                    onClick={() => {
                      setSelectedWorkExperience(workExperience);
                      setOpenAdd(true);
                    }}
                  >
                    <EditIcon fontSize="inherit" />
                  </IconButton>
                  <IconButton
                    color="error"
                    size="small"
                    onClick={() => {
                      setSelectedWorkExperience(workExperience);
                      setOpenDelete(true);
                    }}
                  >
                    <DeleteIcon fontSize="inherit" />
                  </IconButton>
                  <Typography>{index + 1}</Typography>
                </Stack>
              </Card>
            );
          })}
        </Box>
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            flexDirection: "column",
          }}
        >
          <TableContainer>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Sr. No.</TableCell>
                  <TableCell align="left">Company</TableCell>
                  <TableCell align="left">Position</TableCell>
                  <TableCell align="left">Salary / Month</TableCell>
                  <TableCell align="left">Duration</TableCell>
                  <TableCell align="right"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {workExperiences.map((row, index) => (
                  <TableRow key={row.id}>
                    <TableCell component="th" scope="row">
                      {index + 1}
                    </TableCell>
                    <TableCell align="left">{row.companyName}</TableCell>
                    <TableCell align="left">{row.position}</TableCell>
                    <TableCell align="left">{row.salary}</TableCell>
                    <TableCell align="left">
                      {new Date(row.fromDate).toLocaleDateString("hi-IN")} -{" "}
                      {row.isCurrent
                        ? "Till Today"
                        : new Date(row.toDate).toLocaleDateString("hi-IN")}
                    </TableCell>
                    <TableCell align="right">
                      <IconButton
                        variant="outlined"
                        color="primary"
                        size="small"
                        onClick={() => {
                          setSelectedWorkExperience(row);
                          setOpenAdd(true);
                        }}
                      >
                        <EditIcon fontSize="inherit" />
                      </IconButton>
                      <IconButton
                        color="error"
                        size="small"
                        onClick={() => {
                          setSelectedWorkExperience(row);
                          setOpenDelete(true);
                        }}
                      >
                        <DeleteIcon fontSize="inherit" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Grid>
      <Dialog open={openAdd} onClose={handleCancel} fullWidth>
        <DialogContent>
          <WorkExperienceForm
            onSave={handleSave}
            onCancel={handleCancel}
            selectedWorkExperience={selectedWorkExperience}
          />
        </DialogContent>
      </Dialog>
      <Dialog open={openDelete} onClose={handleCancelDelete} fullWidth>
        <DialogTitle>Delete Experience</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete the qualification of{" "}
            <span style={{ color: "#E90000" }}>
              {selectedWorkExperience?.companyName}
            </span>
            ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDelete} variant="contained">
            Yes
          </Button>
          <Button onClick={handleCancelDelete} variant="outlined">
            No
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};

export default WorkExperience;
